import { Helmet } from 'react-helmet'
import { Navigate, useLocation } from 'react-router'

import { Container } from '@/components/Container'
import { OtherProductsSection } from '@/components/quotes/OtherProductsSection'
import { QuoteCartProvider } from '@/components/quotes/QuoteCartContext'
import { QuotesPageSkeleton } from '@/components/quotes/QuotesPageSkeleton'
import { useStaffLinkOpenedEvent } from '@/components/quotes/useStaffLinkOpenedEvent'
import { isOrgAdmin } from '@/models/user'
import { ProductFlowFooter } from '@/routes/Public/marketing/components/ProductFlowFooter'
import {
  QUOTES_FOOTER_NOTE,
  SITE_FOOTER_LEGAL_LINKS,
} from '@/routes/Public/marketing/content/siteFooterContent'
import { InsuranceApplicationView } from './InsuranceApplication'
import { InsuranceApplicationNav } from './InsuranceApplication/InsuranceApplicationNav'
import { useCustomerApplication } from './InsuranceApplication/useCustomerApplication'

/** The customer's quotes page. Until carriers have been asked for prices, /application has the chat. */
export function InsuranceQuotes() {
  useStaffLinkOpenedEvent()
  const { user, application, isLoading, showsQuotes, needsReview } = useCustomerApplication()
  const { search, hash } = useLocation()

  // The provider sits above the nav as well as the page: filled on the page, counted in the nav.
  return (
    <QuoteCartProvider applicationId={application?.id}>
      {/* The cart and the share link belong to the quotes, so they wait for them to be on screen. */}
      <InsuranceApplicationNav
        quotesApplicationId={showsQuotes ? application?.id : undefined}
        awaitingReview={needsReview}
      />
      <Container className="mt-4 flex flex-1 flex-col md:mt-10">
        {!user || isLoading ? (
          <QuotesPageSkeleton />
        ) : !isOrgAdmin(user) || !application ? (
          <Navigate to="/insure/insurance" />
        ) : !showsQuotes ? (
          <Navigate to={{ pathname: '/application', search, hash }} replace />
        ) : (
          <>
            <Helmet>
              <title>Your quotes</title>
            </Helmet>
            <InsuranceApplicationView applicationId={application.id} quotesPage />
          </>
        )}
      </Container>
      {/* Outside the Container on purpose: these bands run the full viewport. */}
      {user && !isLoading && isOrgAdmin(user) && application && showsQuotes && <OtherProductsSection />}
      {(showsQuotes || isLoading || !user) && (
        <ProductFlowFooter legalLinks={SITE_FOOTER_LEGAL_LINKS} note={QUOTES_FOOTER_NOTE} />
      )}
    </QuoteCartProvider>
  )
}
